module.exports = __webpack_public_path__ + "static/img/zichanbg.574159c7.jpg";